export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const SIGNUP_URL = "https://app.smartplaite.com/signup?trial=7";
export const SIGNUP_URL_GENIUS = "https://app.smartplaite.com/signup?plan=genius_monthly&trial=7";
export const SIGNUP_URL_SMART = "https://app.smartplaite.com/signup?plan=smart_monthly&trial=7";
